import { Box, Stack, Typography, styled } from "@mui/material"

export interface LegendItemProp {
  color: string
  title: string
}

export const DoughnutLegend = ({ items }: { items: LegendItemProp[] }) => (
  <LegendContainer>
    {items.map((item) => (
      <LegendItem key={item.title} {...item} />
    ))}
  </LegendContainer>
)

const LegendItem = ({ color, title }: LegendItemProp) => (
  <LegendItemContainer>
    <LegendColor bgcolor={color} />
    <LegendTitle>{title}</LegendTitle>
  </LegendItemContainer>
)

const LegendContainer = styled(Stack)(({ theme: { spacing } }) => ({
  flexDirection: "row",
  justifyContent: "right",
  gap: spacing(2),
  paddingBottom: spacing(2),
}))

const LegendItemContainer = styled(Stack)(({ theme: { spacing } }) => ({
  flexDirection: "row",
  alignItems: "center",
  gap: spacing(1),
  height: "26px",
}))

const LegendColor = styled(Box)({
  width: "20px",
  height: "20px",
  borderRadius: "20px",
})

const LegendTitle = styled(Typography)({})
LegendTitle.defaultProps = {
  variant: "12px",
}
